import {AbstractControl} from "@angular/forms";
import {Component, Input, ViewChild} from "@angular/core";
import {SchoolDataInfoDto} from "../../../models/student-ticket/list-view/SchoolDataInfoDto";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {ModalShellComponent} from "../../../shared/modal/modal-shell/modal-shell.component";
import {SchoolDetailsFormComponent} from "../../../shared/school-details-form/school-details-form.component";

@Component({
  selector: 'app-school-details-adjust-modal',
  templateUrl: './school-details-adjust-modal.component.html',
  styleUrls: ['./school-details-adjust-modal.component.scss'],
  imports: [
    ModalShellComponent,
    SchoolDetailsFormComponent,
  ],
  standalone: true
})
export class SchoolDetailsAdjustModalComponent extends AbstractFormModalComponent {

  @Input() schoolDataInfo: SchoolDataInfoDto;

  protected validationErrorKey = 'SCHOOL_DATA.VALIDATION_ERROR';

  @ViewChild(SchoolDetailsFormComponent) private schoolForm: SchoolDetailsFormComponent;

  protected get form(): AbstractControl {
    return this.schoolForm?.form;
  }

  protected getCloseValue(): unknown {
    return this.schoolForm.getFormValue();
  }
}
